import { useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { FormInput } from "./FormElements";

export default function AmountRange({ ...props }) {


  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const { isResetForm } = useSelector((state) => state.formHelper);
 
  useEffect(()=>{
    if (isResetForm) {
      
      setRangeValue("0", "start");
      setRangeValue("0", "end");
    }

  },[isResetForm]); 

  const setRangeValue = (e, name) => {
    setFieldValue(field.name, {
      ...field.value,
      [name]: e,
    });
  };
  return (
    <div>
      {props.label && (
        <div className="flex items-center text-sm  mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {props.label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}
        </div>
      )}
      <div className="flex flex-row justify-between space-x-2">
        <div className="w-full">
          <FormInput
            name="start"
            placeholder="0.00"
            currencyformat="true"
            currencyicon="true"
            value={field.value.start}
            error={meta.touched && meta.error?.start}
            onValueChange={(val)=>setRangeValue(val.formattedValue,"start")}
            isTRCurrencyDisplay={true}
          />

          {meta.touched && meta.error?.start && (
            <p className="mt-2 text-sm text-error-text">{meta.error?.start}</p>
          )}
        </div>
        <div className="w-full">
          <FormInput
            name="end"
            placeholder="0.00"
            currencyformat="true"
            currencyicon="true"
            error={meta.touched && meta.error?.end}
            value={field.value.end}
            onValueChange={(val)=>setRangeValue(val.formattedValue,"end")}
            isTRCurrencyDisplay={true}
          />
          {meta.touched && meta.error?.end && (
            <p className="mt-2 text-sm text-error-text">{meta.error?.end}</p>
          )}
        </div>
      </div>
    </div>
  );
}